import React from "react";


export const SkillItem = ({text,url})=> {
    return (
        <div class="col mb-4">
            <div class="d-flex align-items-center justify-content-between bg-light rounded-4 p-3 h-100">
                {text}
                {url && <div style={{width: 50}}> <img style={{maxWidth:"100%"}} src={url} alt="..."/></div>}
            </div>
        </div>
    )
}

export const SkillHeader = ({title,iconClass})=>{
    return (
     <div class="d-flex align-items-center mb-4">
        <div class="feature bg-primary bg-gradient-primary-to-secondary text-white rounded-3 me-3"><i class={iconClass}></i></div>
        <h3 class="fw-bolder mb-0"><span class="text-gradient d-inline">{title}</span></h3>
    </div>
    )
}